import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
} from "reactstrap"
import { Link } from "react-router-dom"
//Import Images
import avatar1 from "../../assets/images/users/avatar-1.jpg"
import PropTypes from 'prop-types';


function CardUser(props) {
 
  //Setting Menu
  const toggleSettings = () => {
    setSettingsMenu(settingsMenu)
  }

  return (
    <React.Fragment>
      <Row>
        <Col lg="12">
        {(props.hrProfile == false) && <Alert color="danger"><i className="mdi mdi-bullseye-arrow me-2"></i><strong> Your user account is not connected to any Human Resource Data! Contact System Administrator </strong></Alert> }
          <Card>
            <CardBody>
              <Row>
                <Col lg="4">
                  <div className="d-flex">
                    <div className="me-3">
                      <img
                        src={avatar1}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5 className="mb-1">{props.username}</h5>
                        <p className="mb-0">{props.role}</p>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg="8" className="align-self-center">
                  <div className="text-lg-center mt-4 mt-lg-0">
                    <Row>
                      <Col xs="4">
                        <Link to="#">
                        <div>
                          <p className="text-muted text-truncate mb-2">
                            Verified Collections
                          </p>
                          <h5 className="mb-0">{props.collections}</h5>
                        </div>
                        </Link>
                      </Col>
                      <Col xs="4">
                      <Link to="#">
                        <div>
                          <p className="text-muted text-truncate mb-2">
                            Water Produced
                          </p>
                          <h5 className="mb-0">{props.waterProduced}</h5>
                        </div>
                        </Link>
                      </Col>
                      <Col xs="4">
                        <Link to="#">
                        <div>
                          <p className="text-muted text-truncate mb-2">
                            Today&apos;s Complaints
                          </p>
                          <h5 className="mb-0">{props.noOfComplaints}</h5>
                        </div>
                        </Link>
                      </Col>
                     
                      
                    </Row>
                  </div>
                </Col>

  
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}
CardUser.propTypes = {
  username: PropTypes.any,
  role: PropTypes.any,
  collections:PropTypes.any,
  waterProduced: PropTypes.any,
  noOfComplaints: PropTypes.any,
  hrProfile: PropTypes.any
};
export default CardUser
